import { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from './supabaseClient';

function Scan() {
  const [medicineData, setMedicineData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const hasLogged = useRef(false);

  useEffect(() => {
    const fetchAndTrack = async () => {
      if (hasLogged.current) return; // 🔒 Prevent double execution
      hasLogged.current = true;

      const params = new URLSearchParams(location.search);
      const id = params.get('id');

      if (!id) {
        setError('Invalid QR code');
        setLoading(false);
        return;
      }

      const { data, error } = await supabase
        .from('medicines')
        .select('*')
        .eq('id', id)
        .single();

      if (error || !data) {
        setError('Medicine not found');
        setLoading(false);
        return;
      }

      setMedicineData(data);

      await supabase.from('qr_scans').insert([
        {
          medicine_id: id,
          scan_type: 'verification',
          user_agent: navigator.userAgent,
        },
      ]);

      setLoading(false);
    };

    fetchAndTrack();
  }, [location.search]);

  if (loading) {
    return <p style={{ padding: 20 }}>Verifying medicine authenticity…</p>;
  }

  if (error) {
    return <p style={{ padding: 20, color: 'red' }}>{error}</p>;
  }

  return (
    <div style={{ padding: 20 }}>
      <h2 style={{ color: 'green' }}>✔ Genuine Medicine</h2>

      <p>
        <b>Brand:</b> {medicineData.brand_name}
      </p>
      <p>
        <b>Drug Name:</b> {medicineData.drug_name}
      </p>
      <p>
        <b>Batch No:</b> {medicineData.batch_no}
      </p>
      <p>
        <b>Mfg Date:</b> {medicineData.mfg_date}
      </p>
      <p>
        <b>Expiry Date:</b> {medicineData.exp_date}
      </p>
      <p>
        <b>Manufacturer:</b> {medicineData.manufacturer}
      </p>
      <p>
        <b>Manufacturing Address:</b> {medicineData.manufacturing_address}
      </p>
      <p>
        <b>Marketed By:</b> {medicineData.marketed_by}
      </p>
      <p>
        <b>License No:</b> {medicineData.license_no}
      </p>
      <p>
        <b>MRP:</b> ₹{medicineData.mrp}
      </p>
      <p>
        <b>Storage:</b> {medicineData.storage}
      </p>
    </div>
  );
}

export default Scan;
